import { useAtom } from 'jotai';
import React from 'react';
import styled from 'styled-components';

import { PageId } from '../enum/PageId';
import { usePages } from '../hooks/use-pages';
import { reservationDataAtom } from '../jotai-atoms/reservation-data.atom';
import { userAtom } from '../jotai-atoms/user.atom';
import { CountdownWidget } from '../stories/CountdownWidget/CountdownWidget';

interface BannerCountdownProps {
  show?: boolean;
}

export const BannerCountdown: React.FC<BannerCountdownProps> = ({ show }) => {
  const [user] = useAtom(userAtom);
  const [reservationData] = useAtom(reservationDataAtom);

  const nextLiveClass = user?.nextLiveClass;
  const { pageId, isPublicPage } = usePages();

  if (
    !show ||
    !nextLiveClass ||
    isPublicPage ||
    pageId === PageId.Level ||
    pageId === PageId.Play2learnZoom
  ) {
    return null;
  }

  return (
    <>
      <Container hide={reservationData?.widgetState === 'class_later'}>
        <CountdownWidget size="sm" />
      </Container>
    </>
  );
};

interface ContainerProps {
  hide: boolean;
}
const Container = styled.div<ContainerProps>`
  display: ${({ hide }) => (hide ? `none` : `flex`)};
  background-color: #fff5cc;
  height: 56px;
  align-items: center;
  justify-content: center;
`;
